export const gallery = [
  {
    id: "g1",
    src: "https://storage.helloreaddy.io/project_files/0469b4b9-4faa-42c6-9db9-282aa399951a/3e777104-98be-48cc-a1a8-595e926eb4d1_compressed_IMG_2837.webp",
    title: "Rasenpflege",
    subtitle: "Gestreifter Rasen nach dem Mähen",
    tall: true,
  },
  {
    id: "g2",
    src: "https://storage.helloreaddy.io/project_files/0469b4b9-4faa-42c6-9db9-282aa399951a/20b96998-8504-4911-b6d9-a64d867dc43d_compressed_IMG_2839.webp",
    title: "Heckenschnitt",
    subtitle: "Saubere Kanten bis zur Nachbargrenze",
    tall: false,
  },
  {
    id: "g3",
    src: "https://storage.helloreaddy.io/project_files/0469b4b9-4faa-42c6-9db9-282aa399951a/403c06cc-3760-4bde-bf42-4ef85b0cc399_compressed_IMG_2835.webp",
    title: "Beet- & Gehölzpflege",
    subtitle: "Gepflegte Beete und Pflanzgefäße",
    tall: false,
  },
  {
    id: "g4",
    src: "https://storage.helloreaddy.io/project_files/0469b4b9-4faa-42c6-9db9-282aa399951a/8afc7609-40d1-4ae0-ad18-82d9d2dfd6d5_compressed_IMG_2836.webp",
    title: "Außenanlage Tennisplatz",
    subtitle: "Formschnitt der Heckenreihen",
    tall: true,
  },
  {
    id: "g5",
    src: "https://storage.helloreaddy.io/project_files/0469b4b9-4faa-42c6-9db9-282aa399951a/ba9185f1-cad1-4477-800b-72d7b0de0117_compressed_IMG_2838.webp",
    title: "Formgehölze",
    subtitle: "Konturschnitt von Buchs & Kugelgehölzen",
    tall: false,
  },
];